import { CommunityFeedItemDto } from 'src/Services/API/generated';

// Helper type for objects that only contain an id
type WithId = { id: string };

export function communityFeedItemUrl(feedItem: CommunityFeedItemDto): string | null {
  const asset = feedItem.assets[0];

  if (!asset) return null;

  let url = null;

  if (feedItem.instruction) {
    url = `${asset.id}/guides/instructions/${(feedItem.instruction as WithId).id}`;
  }
  if (feedItem.expense) {
    url = `${asset.id}/expenses/${(feedItem.expense as WithId).id}`;
  }
  if (feedItem.checklist) {
    url = `${asset.id}/guides/checklists/${(feedItem.checklist as WithId).id}/submissions`;
  }
  if (feedItem.contact) {
    url = `${asset.id}/contacts/${(feedItem.contact as WithId).id}`;
  }
  if (feedItem.practicalInformation) {
    url = `${asset.id}/infos/practical-info/${(feedItem.practicalInformation as WithId).id}`;
  }
  if (feedItem.event) {
    url = `${asset.id}/event/${(feedItem.event as WithId).id}`;
  }
  if (feedItem.project) {
    url = `${asset.id}/project-and-works/${(feedItem.project as WithId).id}`;
  }
  if (feedItem.bankAccount) {
    url = `${asset.id}/expenses/bank-account/${(feedItem.bankAccount as WithId).id}`;
  }
  // Documents and money transfers don't have dedicated drawers in the community context,
  // so we navigate to the asset's documents/expenses page instead
  if (feedItem.document) {
    url = `/asset/${asset.id}/documents`;
  }
  if (feedItem.moneyTransfer) {
    url = `/asset/${asset.id}/expenses`;
  }

  return url;
}
